import React, { useLayoutEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import { Tooltip } from "@td/ui";

const PracticeName = React.memo(({ children }) => {
  const containerRef = useRef();
  const [tooltipTitle, setTooltipTitle] = useState(null);

  useLayoutEffect(() => {
    const resolveTooltipTitle = () => {
      setTooltipTitle(
        containerRef.current.scrollWidth > containerRef.current.offsetWidth
          ? children
          : null
      );
    };

    resolveTooltipTitle();
    window.addEventListener("resize", resolveTooltipTitle);

    return () => {
      window.removeEventListener("resize", resolveTooltipTitle);
    };
  }, [containerRef.current, setTooltipTitle, children]);

  return (
    <Tooltip title={tooltipTitle}>
      <div
        ref={containerRef}
        className={styles.practiceName}
        data-testid="practice-name"
      >
        {children}
      </div>
    </Tooltip>
  );
});

PracticeName.propTypes = {
  children: PropTypes.node.isRequired,
};

PracticeName.displayName = "PracticeName";

export default PracticeName;
